// Shared display helpers for v2 material-movement rows. Used by the global
// Transaction History page and the WO detail drawer's History tab so the
// movement-type chip colours and labels stay identical across both.

// MUI Chip `color` prop per movement type. Mirrors the mapping specified for
// the Transaction History table:
//   receipt=success, issue=info, scrap=error, reservation=default,
//   reservation_release=warning, adjustment=secondary.
export const MOVEMENT_TYPE_COLORS = {
  receipt: 'success',
  issue: 'info',
  scrap: 'error',
  reservation: 'default',
  reservation_release: 'warning',
  adjustment: 'secondary',
};

// Human-friendly labels for each movement type.
export const MOVEMENT_TYPE_LABELS = {
  receipt: 'Receipt',
  issue: 'Issue',
  scrap: 'Scrap',
  reservation: 'Reservation',
  reservation_release: 'Reservation Release',
  adjustment: 'Adjustment',
};

// Options for a movement-type multi-select filter. Order matches the ledger's
// natural lifecycle (reserve → release → issue → receipt → scrap → adjust).
export const MOVEMENT_TYPE_OPTIONS = [
  'reservation',
  'reservation_release',
  'issue',
  'receipt',
  'scrap',
  'adjustment',
];

export function movementTypeColor(type) {
  return MOVEMENT_TYPE_COLORS[type] || 'default';
}

export function movementTypeLabel(type) {
  if (MOVEMENT_TYPE_LABELS[type]) return MOVEMENT_TYPE_LABELS[type];
  // Fallback: prettify an unknown snake_case type.
  return String(type || '')
    .split('_')
    .map((w) => (w ? w[0].toUpperCase() + w.slice(1) : w))
    .join(' ');
}

// Format a signed quantity for display. Movements store magnitude + type; we
// render a sign so operators can read direction at a glance (issues/scrap/
// reservations consume stock → negative; receipts/releases add → positive).
export function signedQuantity(row) {
  const qty = parseFloat(row?.quantity);
  if (Number.isNaN(qty)) return '';
  const negativeTypes = new Set(['issue', 'scrap', 'reservation']);
  // Adjustments already carry their own sign from the backend; respect it.
  if (row.movement_type === 'adjustment') {
    return qty > 0 ? `+${qty}` : String(qty);
  }
  const magnitude = Math.abs(qty);
  if (negativeTypes.has(row.movement_type)) return `-${magnitude}`;
  return `+${magnitude}`;
}
